import Api from '@/services/Index'

const sendSms = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/fashion/design/application/start', data)
}

const verifySms = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/fashion/design/application/verify', data)
}

const login = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/fashion/design/application/login', data)
}

const updatePersonalInfo = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/fashion/design/application/update-personal-information', data)
}

const updateEducationInfo = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/fashion/design/application/update-education-information', data)
}

const updateApplicationInfo = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/fashion/design/application/update-application-information', data)
}

const passwordReminder = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/fashion/design/application/password-reminder', formData)
}

const downloadFileApplicationSide = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/fashion/design/application/download-document', formData, {responseType: 'arraybuffer'})
}

/// Admin
const getAll = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.get('/fashion/design/applications', config)
}

const update = async (formData, id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.put('/fashion/design/applications/'+id, formData)
}

const downloadFile = async (applicationId) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.get('/fashion/design/applications/download-file/'+applicationId, {responseType: 'arraybuffer'})
}

const bulkMessage = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/fashion/design/applications/bulk-message', formData)
}

const sendMessage = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/fashion/design/application/messages', formData)
}

const updateMessage = async (formData, id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.put('/fashion/design/application/messages/'+id, formData)
}

const deleteMessage = async (messageId) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.delete('/fashion/design/application/messages/'+messageId)
}

const searchHighschools = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/fashion/design/application/high-schools', formData)
}

const makePayment = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/fashion/design/application/make-payment', formData)
}

const applicationExcelExport = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.get('/fashion/design/applications/excel-export', {...config, responseType: 'arraybuffer'})
}

const deleteApplication = async (Id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.delete('/fashion/design/applications/'+Id)
}

const examInformationExcelExport = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.get('/fashion/design/applications/exam-information-excel-export', {...config, responseType: 'arraybuffer'})
}

const importExamInformationExcelImport = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/fashion/design/applications/exam-information-excel-import', formData)
}

const examResultExcelExport = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.get('/fashion/design/applications/exam-result-excel-export', {responseType: 'arraybuffer'})
}

const importExamResultExcelImport = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/fashion/design/applications/exam-result-excel-import', formData)
}

const calculatePlacementPoints = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.get('/fashion/design/application/calculate-placement-points')
}

const createPlacedStudentList = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.get('/fashion/design/application/place-students', {responseType: 'arraybuffer'})
}

const resultPublish = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.get('/fashion/design/application/publish')
}
const getMernis = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/fashion/design/application/mernis-data', formData)
}
/// Quotas
const getAllQuotas = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.get('/fashion/design/application/quotas', config)
}

const storeQuota = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/fashion/design/application/quotas', formData)
}

const getQuota = async (Id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.get('/fashion/design/application/quotas/'+Id)
}

const updateQuota = async (Id, formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.put('/fashion/design/application/quotas/'+Id, formData)
}

const deleteQuota = async (Id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.delete('/fashion/design/application/quotas/'+Id)
}
///*------------------------*
const approveConsent = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/fashion/design/application/approve-consent', formData)
}

// Exam Types
const getAllExamTypes = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.get('/fashion/design/application/exam-types', config)
}

const storeExamType = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/fashion/design/application/exam-types', formData)
}

const getExamType = async (Id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.get('/fashion/design/application/exam-types/'+Id)
}

const updateExamType = async (Id, formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.put('/fashion/design/application/exam-types/'+Id, formData)
}

const delExamType = async (Id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.delete('/fashion/design/application/exam-types/'+Id)
}
//#------------------------------#
const calculateExamPoints = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.get('/fashion/design/application/calculate-exam-points')
}

const getExams = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.get('/fashion/design/application/exams', config)
}

const updateExam = async (formData, Id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.put('/fashion/design/application/exams/'+Id, formData)
}

const importBulkExcel = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/fashion/design/applications/excel-import', formData)
}

const getExamList = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.post('/fashion/design/application/exam-list', formData)
}

const updateExamPoints = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.get('/fashion/design/application/update-exam-points', config)
}

const evaluateProgramResults = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.get('/fashion/design/application/evaluate-program-results')
}

const registerApplications = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.get('/fashion/design/application/register', config)
}

const graduateDateUpdate = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT
    return Api.get('/fashion/design/application/update-school-graduate-dates')
}

export default {
    sendSms,
    verifySms,
    login,
    updatePersonalInfo,
    updateEducationInfo,
    updateApplicationInfo,
    getAll,
    passwordReminder,
    update,
    downloadFile,
    downloadFileApplicationSide,
    bulkMessage,
    sendMessage,
    updateMessage,
    deleteMessage,
    searchHighschools,
    makePayment,
    applicationExcelExport,
    deleteApplication,
    examInformationExcelExport,
    importExamInformationExcelImport,
    examResultExcelExport,
    importExamResultExcelImport,
    calculatePlacementPoints,
    createPlacedStudentList,
    resultPublish,
    getAllQuotas,
    storeQuota,
    getQuota,
    updateQuota,
    deleteQuota,
    getMernis,
    approveConsent,
    getAllExamTypes,
    storeExamType,
    getExamType,
    updateExamType,
    delExamType,
    calculateExamPoints,
    getExams,
    updateExam,
    importBulkExcel,
    getExamList,
    updateExamPoints,
    evaluateProgramResults,
    registerApplications,
    graduateDateUpdate

}
